import { Collapse } from '@mui/material';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { downloadAppURL } from '../../../constants/appURL/downloadAppURL.constant';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { termsOfUse } from '../../../constants/termsOfUse/termsOfUse.constant';
import { postMessageToRN } from '../../../utils/RNCommunicator/postMessageToRN.util';
import { SlideModal } from '../../abstract/modal/slide/SlideModal';
import { Icon } from '../../common/icon/Icon';
import { TermsOfUseContent, TermsOfUseHeader, TermsOfUseModalContent } from '../modal/termsOfUseModal/termsOfUseModal';

export const CompanyInfo = () => {
  const [isShowCompanyInfo, setIsShowCompanyInfo] = useState<boolean>(false);
  const [isShowSupportInfo, setIsShowSupportInfo] = useState<boolean>(false);
  const [isShowDisclaimerInfo, setIsShowDisclaimerInfo] = useState<boolean>(false);

  const [isPersonalInfomationModalOpen, setIsPersonalInfomationModalOpen] = useState<boolean>(false);
  const [isPluvaMarketModalOpen, setIsPluvaMarketModalOpen] = useState<boolean>(false);
  const [isMarketingModalOpen, setIsMarketingModalOpen] = useState<boolean>(false);

  const navigate = useNavigate();

  const location = useLocation();

  // TODO : CompanyInfo 컴포넌트가 렌더링되지 않는 페이지에 대한 처리 방식 개선 [https://gint-team.atlassian.net/browse/PVM-1579]
  if (
    location.pathname.includes('survey') ||
    location.pathname === pageInfo.downloadAppPage.path ||
    location.pathname.includes('join')
  ) {
    return <></>;
  }

  return (
    <>
      <Container>
        <Section>
          <ToggleButton onClick={() => setIsShowCompanyInfo((prev) => !prev)}>
            <ToggleButtonTitle>{'플루바 마켓 사업자 정보'}</ToggleButtonTitle>
            {isShowCompanyInfo ? (
              <Icon name={'AngleUp'} width={9} height={5} />
            ) : (
              <Icon name={'AngleDown'} width={9} height={5} />
            )}
          </ToggleButton>
          <Collapse in={isShowCompanyInfo} style={{ width: '100%' }}>
            <DetailSection>
              <InfoSection>
                <RowWrapper>
                  <TextSection>{'회사명\n대표\n사업자 등록번호\nE-mail\n개인정보담당'}</TextSection>
                  <TextSection>{'GINT Co.,Ltd.\n김용현\n266-88-00215\nsupport@gintlab.com\n김용현'}</TextSection>
                </RowWrapper>
              </InfoSection>

              <HR />

              <InfoSection>
                <HeaderWrap>
                  <Icon name={'Marker'} width={16} height={16} />
                  <HeaderText>{'판교 본사'}</HeaderText>
                </HeaderWrap>
                <TextSection>
                  {'경기도 성남시 분당구 삼평동 633\n판교세븐벤처밸리 2단지 1동 4층 플루바 마켓'}
                </TextSection>
                <TextSection>{'전화: 031-212-4994\n팩스: 031-212-7840'}</TextSection>
                <GreyChip>
                  <ChipText>{'상담 가능 시간: 오전 9시 ~ 오후 6시'}</ChipText>
                </GreyChip>
              </InfoSection>
            </DetailSection>
          </Collapse>
        </Section>

        <Section>
          <ToggleButton onClick={() => setIsShowSupportInfo((prev) => !prev)}>
            <ToggleButtonTitle>{'고객 지원'}</ToggleButtonTitle>
            {isShowSupportInfo ? (
              <Icon name={'AngleUp'} width={9} height={5} />
            ) : (
              <Icon name={'AngleDown'} width={9} height={5} />
            )}
          </ToggleButton>
          <Collapse in={isShowSupportInfo} style={{ width: '100%' }}>
            <DetailSection>
              <InfoSection>
                <MenuItem onClick={() => navigate('/noti')}>{'공지사항'}</MenuItem>
                <MenuItem
                  onClick={() => {
                    if (window.ReactNativeWebView) {
                      postMessageToRN({ messageKey: 'link', messageParam: 'http://pf.kakao.com/_DrLDxj/chat' });
                    } else {
                      window.open(
                        'http://pf.kakao.com/_DrLDxj/chat',
                        '_blank',
                        'popup=yes, width=450, height=700, top=20, left=120',
                      );
                    }
                  }}
                >
                  {'카카오톡 1:1 문의'}
                </MenuItem>
              </InfoSection>
            </DetailSection>
          </Collapse>
        </Section>

        <Section>
          <ToggleButton onClick={() => setIsShowDisclaimerInfo((prev) => !prev)}>
            <ToggleButtonTitle>{'법적 고지사항'}</ToggleButtonTitle>
            {isShowDisclaimerInfo ? (
              <Icon name={'AngleUp'} width={9} height={5} />
            ) : (
              <Icon name={'AngleDown'} width={9} height={5} />
            )}
          </ToggleButton>
          <Collapse in={isShowDisclaimerInfo} style={{ width: '100%' }}>
            <DetailSection>
              <InfoSection>
                <MenuItem onClick={() => setIsPluvaMarketModalOpen(true)}>{'플루바 마켓 회원 이용약관'}</MenuItem>
                <MenuItem onClick={() => setIsPersonalInfomationModalOpen(true)}>
                  {'개인정보 수집 및 이용안내'}
                </MenuItem>
                <MenuItem onClick={() => setIsMarketingModalOpen(true)}>{'마케팅 목적 개인정보 및 이용안내'}</MenuItem>
              </InfoSection>
            </DetailSection>
          </Collapse>
        </Section>

        <CopyRights>{'© GINT Co.,Ltd. All Rights Reserved.'}</CopyRights>

        {!window.ReactNativeWebView && (
          <DownloadAppSection>
            <DownloadAppButton
              onClick={() => {
                window.location.href = downloadAppURL.android;
              }}
            >
              <Icon name={'PlayStore'} width={20} height={20} />
            </DownloadAppButton>
            <DownloadAppButton
              onClick={() => {
                window.location.href = downloadAppURL.ios;
              }}
            >
              <Icon name={'AppStore'} width={20} height={20} />
            </DownloadAppButton>
          </DownloadAppSection>
        )}
      </Container>

      <SectionForBottomNavigation />

      <SlideModal
        isSlideModalOpen={isPluvaMarketModalOpen}
        closeAll={() => setIsPluvaMarketModalOpen(false)}
        showSlideButton={false}
        showBottomCloseButton
      >
        <TermsOfUseModalContent>
          <TermsOfUseHeader>{termsOfUse.pluvaMarket.header.trim()}</TermsOfUseHeader>
          <TermsOfUseContent>{termsOfUse.pluvaMarket.content.trim()}</TermsOfUseContent>
        </TermsOfUseModalContent>
      </SlideModal>
      <SlideModal
        isSlideModalOpen={isPersonalInfomationModalOpen}
        closeAll={() => setIsPersonalInfomationModalOpen(false)}
        showSlideButton={false}
        showBottomCloseButton
      >
        <TermsOfUseModalContent>
          <TermsOfUseHeader>{termsOfUse.personalinfomation.header.trim()}</TermsOfUseHeader>
          <TermsOfUseContent>{termsOfUse.personalinfomation.content.trim()}</TermsOfUseContent>
        </TermsOfUseModalContent>
      </SlideModal>
      <SlideModal
        isSlideModalOpen={isMarketingModalOpen}
        closeAll={() => setIsMarketingModalOpen(false)}
        showSlideButton={false}
        showBottomCloseButton
      >
        <TermsOfUseModalContent>
          <TermsOfUseHeader>{termsOfUse.marketing.header.trim()}</TermsOfUseHeader>
          <TermsOfUseContent>{termsOfUse.marketing.content.trim()}</TermsOfUseContent>
        </TermsOfUseModalContent>
      </SlideModal>
    </>
  );
};

const Container = styled.div`
  width: 100%;
  min-height: 200px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  gap: 24px;

  padding: 32px 16px;
  padding-bottom: 42px;

  background-color: #e4e4ed;
`;

const Section = styled.div`
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  flex-direction: column;
`;

const ToggleButton = styled.button`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ToggleButtonTitle = styled.h3`
  color: #505363;
  font-size: 14px;
  font-weight: 700;
  line-height: 85%; /* 11.9px */
`;

const CopyRights = styled.span`
  color: #505363;
  font-size: 12px;
  font-weight: 400;
  line-height: 85%; /* 10.2px */
`;

const DownloadAppSection = styled.div`
  display: flex;
  gap: 10px;
`;

const DownloadAppButton = styled.div`
  width: 36px;
  height: 36px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 80px;
  background: #d5d5e3;

  cursor: pointer;
`;

const SectionForBottomNavigation = styled.div`
  width: 100%;
  height: 72px;

  background-color: #e4e4ed;
`;

const DetailSection = styled.div<{ gap?: string }>`
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;

  gap: ${(props) => props.gap ?? '16px'};

  margin-top: 16px;
`;

const HR = styled.hr`
  width: 100%;
  height: 0px;

  border: 0.5px solid #c6c6d5;
`;

const HeaderText = styled.span`
  color: #505363;
  font-size: 12px;
  font-weight: 700;
  line-height: 85%; /* 10.2px */
`;

const TextSection = styled.pre`
  color: #505363;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 18px */
`;

const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  gap: 8px;
`;

const RowWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const HeaderWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const GreyChip = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  border-radius: 4px;
  background: #505363;

  padding: 4px 6px;
  gap: 10px;
`;

const ChipText = styled.span`
  color: #fff;
  text-align: center;
  font-size: 10px;
  font-weight: 500;
  line-height: 85%; /* 8.5px */
`;

const MenuItem = styled.span`
  color: #505363;
  font-size: 12px;
  font-weight: 400;
  line-height: 130%; /* 15.6px */

  cursor: pointer;
`;
